import React from "react";

import IconButton from "@mui/material/IconButton";
import { useOperationDespatchContext } from "../../../../contexts/DespatchContext";
import { Maximize3 as IconMaximize } from "iconsax-react";

export const DiaryHeaderFullscreenToogleButton = () => {
  const { isFullscreen, toogleFullscreen } = useOperationDespatchContext();

  if (isFullscreen) return null;

  return (
    <IconButton onClick={toogleFullscreen} size="large" color="inherit">
      <IconMaximize size={20} />
    </IconButton>
  );
};
